import { Component } from '@angular/core';


@Component({
  selector: 'app-negociables',
  templateUrl: './negociables.component.html',
  styleUrls: ['./negociables.component.css']
})
export class NegociablesComponent   {
   


 
}
